import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState, useEffect } from 'react';
import { Button, ModalBody, ModalHeader, ModalFooter, FormGroup } from 'reactstrap';
import { avLogMessagesApi, avRegionsApi } from '@availity/api-axios';
import { Form, Field } from '@availity/form';
import { SelectField } from '@availity/select';
import * as yup from 'yup';
import SmileField from './SmileField';
yup.addMethod(yup.string, 'isRequired', function format(isRequired, msg) {
  return this.test({
    name: 'dateRange',
    exclusive: true,
    message: msg || 'This field is required.',
    test: function test(value) {
      if (isRequired) {
        return value !== undefined;
      }

      return true;
    }
  });
});

var FeedbackForm = function FeedbackForm(_ref) {
  var name = _ref.name,
      onClose = _ref.onClose,
      faceOptions = _ref.faceOptions,
      aboutOptions = _ref.aboutOptions,
      onFeedbackSent = _ref.onFeedbackSent,
      prompt = _ref.prompt,
      additionalComments = _ref.additionalComments,
      staticFields = _ref.staticFields,
      modalHeaderProps = _ref.modalHeaderProps,
      formProps = _objectWithoutPropertiesLoose(_ref, ["name", "onClose", "faceOptions", "aboutOptions", "onFeedbackSent", "prompt", "additionalComments", "staticFields", "modalHeaderProps"]);

  var _useState = useState(null),
      active = _useState[0],
      setActive = _useState[1];

  var _useState2 = useState(null),
      sent = _useState2[0],
      setSent = _useState2[1];

  var sendFeedback = function sendFeedback(_ref2) {
    var smileField, values, response;
    return _regeneratorRuntime.async(function sendFeedback$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            smileField = _ref2.smileField, values = _objectWithoutPropertiesLoose(_ref2, ["smileField"]);
            _context.next = 3;
            return _regeneratorRuntime.awrap(avRegionsApi.getCurrentRegion());

          case 3:
            response = _context.sent;
            _context.next = 6;
            return _regeneratorRuntime.awrap(avLogMessagesApi.info(_objectSpread({
              surveyId: name.replace(/\s/g, '_') + "_Smile_Survey",
              smileLocation: "" + name,
              smile: "icon-" + smileField.icon,
              url: window.location.href,
              region: response.data.regions[0] && response.data.regions[0].id,
              userAgent: window.navigator.userAgent,
              submitTime: new Date()
            }, values, {}, staticFields)));

          case 6:
            setSent(values);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    });
  }; // Close the Modal once sent after 2 seconds


  useEffect(function () {
    if (sent) {
      setTimeout(function () {
        if (onClose) {
          onClose(); // Mostly for Screen Reader use but a nice to have for all
        }

        if (onFeedbackSent) {
          Object.keys(sent).forEach(function (key) {
            return sent[key] === undefined && delete sent[key];
          });
          onFeedbackSent(_objectSpread({
            active: active.icon
          }, sent));
        }
      }, 2000);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [sent]);
  return sent ? React.createElement(ModalHeader, Object.assign({
    "aria-live": "assertive",
    tabIndex: "0",
    className: "d-flex justify-content-center"
  }, modalHeaderProps), "Thank you for your feedback.") : React.createElement(React.Fragment, null, React.createElement(ModalHeader, Object.assign({
    "aria-live": "assertive",
    id: "feedback-form-header"
  }, modalHeaderProps), prompt || "Tell us what you think about " + name), React.createElement(Form, Object.assign({
    "aria-label": "Feedback Form",
    "aria-describedby": "feedback-form-header",
    role: "form",
    "data-testid": "feedback-form",
    initialValues: {
      'face-options': undefined,
      additionalFeedback: undefined,
      feedback: undefined,
      feedbackApp: undefined,
      smileField: undefined
    },
    validationSchema: yup.object().shape({
      feedback: yup.string().max(200, 'Additional Feedback cannot exceed 200 characters.').required('This field is required.'),
      additionalFeedback: yup.string().max(200, 'Additional Feedback cannot exceed 200 characters.'),
      smileField: yup.object().shape({
        icon: yup.string().required(),
        description: yup.string(),
        placeholder: yup.string()
      }).required('This field is required.'),
      feedbackApp: yup.string().isRequired(aboutOptions.length > 0, 'This field is required.')
    })
  }, formProps, {
    onSubmit: function onSubmit(values) {
      return sendFeedback(values);
    }
  }), React.createElement(ModalBody, null, React.createElement(FormGroup, {
    size: "lg",
    id: "face-options",
    "data-testid": "face-options",
    className: "d-flex flex-row justify-content-between"
  }, React.createElement(SmileField, {
    options: faceOptions,
    name: "smileField",
    onChange: function onChange(option) {
      return setActive(option);
    }
  })), active ? React.createElement(React.Fragment, null, aboutOptions.length > 0 && React.createElement(SelectField, {
    name: "feedbackApp",
    id: "about-options",
    "data-testid": "about-options",
    placeholder: "This is about...",
    options: aboutOptions
  }), React.createElement(Field, {
    type: "textarea",
    name: "feedback",
    placeholder: active && active.placeholder || 'Feedback? Requests? Defects?',
    style: {
      resize: 'none'
    },
    rows: "2"
  }), additionalComments && React.createElement(Field, {
    type: "textarea",
    name: "additionalFeedback",
    placeholder: "Additional Comments... (Optional)",
    style: {
      resize: 'none'
    },
    rows: "2"
  })) : null), React.createElement(ModalFooter, null, onClose ? React.createElement(Button, {
    onClick: onClose,
    color: "secondary",
    onKeyDown: function onKeyDown(_ref3) {
      var keyCode = _ref3.keyCode;
      return keyCode === 13 && onClose();
    }
  }, "Close") : null, React.createElement(Button, {
    type: "submit",
    color: "primary",
    disabled: !active
  }, "Send Feedback"))));
};

FeedbackForm.defaultProps = {
  aboutOptions: [],
  additionalComments: false,
  modalHeaderProps: {}
};
export default FeedbackForm;